import MayoLanding from "../common/MayoLanding";

import doctorImage from "../../../../assets/Mayo/Doctor1.png";

export default function MayoLanding2Angiogram() {
  return <MayoLanding
    title={"Welcome"}
    text={"Understanding and committing to the instructions are essential for your upcoming Angiogram, as they play a vital role in your recovery journey!"}
    image={doctorImage}
    buttonText={"Start"}
    navigateTo={"/patient/mayo/video_page2_angiogram"}
    postAnalyticType="messageOpnedAngiogram"
  />
}